/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Settings({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 5.65a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2m-1.4 2.6a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M9.375 1.867a1.678 1.678 0 0 0-2.75 0l-.877 1.265a.47.47 0 0 1-.425.199l-1.555-.116C2.612 3.13 1.697 4.221 2.052 5.348l.46 1.463a.43.43 0 0 1-.1.43L1.35 8.363c-.811.857-.48 2.241.613 2.661l1.451.558c.159.061.265.197.289.351l.23 1.514c.178 1.16 1.474 1.754 2.48 1.183l1.35-.767a.48.48 0 0 1 .475 0l1.35.767c1.005.571 2.301-.023 2.478-1.183l.231-1.514a.45.45 0 0 1 .288-.35l1.452-.559c1.092-.42 1.424-1.804.613-2.661L13.589 7.24a.43.43 0 0 1-.101-.43l.46-1.463c.355-1.127-.56-2.219-1.716-2.133l-1.555.116a.47.47 0 0 1-.425-.199zm-1.764.683a.478.478 0 0 1 .778 0l.877 1.266c.338.487.91.755 1.5.711l1.555-.115a.453.453 0 0 1 .483.576l-.461 1.462a1.63 1.63 0 0 0 .374 1.616l1.061 1.121a.44.44 0 0 1-.172.717l-1.451.558a1.65 1.65 0 0 0-1.044 1.29l-.231 1.514a.47.47 0 0 1-.7.32l-1.35-.766a1.68 1.68 0 0 0-1.66 0l-1.35.766a.47.47 0 0 1-.7-.32l-.23-1.514a1.65 1.65 0 0 0-1.045-1.29l-1.451-.558a.44.44 0 0 1-.172-.717l1.06-1.121a1.63 1.63 0 0 0 .375-1.616l-.46-1.462a.453.453 0 0 1 .482-.576l1.555.115a1.67 1.67 0 0 0 1.5-.711z" clipRule="evenodd" /></svg>;
}
;